import { useContext } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useTranslation } from "react-i18next";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";

type Props = {};
const SiteFrequentlyAskedQuestionsComponent = (props: Props) => {
  const { t } = useTranslation();

  function ContextAwareToggle({
    eventKey,
    callback,
    children
  }: {
    eventKey: string;
    callback?: any;
    children?: any;
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        {!isCurrentEventKey && (
          <div
            onClick={decoratedOnClick}
            className="d-flex justify-content-between align-items-center w-100 cursor-pointer"
          >
            <div>{children}</div>
            <div>
              <BsPlusLg
                style={{ cursor: "pointer" }}
                className="color-thirdColor"
                onClick={decoratedOnClick}
              />
            </div>
          </div>
        )}
        {isCurrentEventKey && (
          <div
            onClick={decoratedOnClick}
            className="d-flex justify-content-between align-items-center w-100 cursor-pointer"
          >
            <div>{children}</div>
            <div>
              <BiMinus
                style={{ cursor: "pointer" }}
                className="color-thirdColor"
                onClick={decoratedOnClick}
              />
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <section className="frequently-asked-questions">
      <Container fluid={"xl"}>
        <Row className="mt-4 p-lg-5 mb-4">
          <Col>
            <Row>
              <Col className="d-flex justify-content-center text-center">
                <h1 className="font-sofiaSans fw-bolder">
                  {t("home/SiteFrequentlyAskedQuestions/title")}
                </h1>
              </Col>
            </Row>
            <Row className="mt-4 px-lg-5">
              <Col className="px-lg-5">
                <Accordion className="px-lg-5">
                  <Accordion.Item
                    eventKey="0"
                    className="my-2 border-0   rounded-4 bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="0">
                        <span className="font-sofiaSans fw-bold ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/q-01")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-01")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="1"
                    className="my-2 border-0   rounded-4 bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="1">
                        <span className="font-sofiaSans fw-bold ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/q-02")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-02")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="2"
                    className="my-2  border-0  rounded-4  bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="2">
                        <span className="font-sofiaSans fw-bold ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/q-03")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="rounded-4 color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-03")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="3"
                    className="my-2 border-0  rounded-4 bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="3">
                        <span className="font-sofiaSans fw-bold  ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/text-04")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-05")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="4"
                    className="my-2 border-0  rounded-4 bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="4">
                        <span className="font-sofiaSans fw-bold  ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/text-06")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-07")}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="5"
                    className="my-2 border-0  rounded-4 bg-tenColor"
                  >
                    <div className="accordion-header ">
                      <ContextAwareToggle eventKey="5">
                        <span className="font-sofiaSans fw-bold  ps-lg-3">
                          {t("home/SiteFrequentlyAskedQuestions/q-04")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body className="color-fifteenColor font-sofiaSans fs-5">
                      {t("home/SiteFrequentlyAskedQuestions/text-08")}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteFrequentlyAskedQuestionsComponent;
